/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.settings.SettingType
*/
export var SettingType;
(function (SettingType) {
    SettingType["STRING"] = "STRING";
    SettingType["INT"] = "INT";
    SettingType["LONG"] = "LONG";
    SettingType["DOUBLE"] = "DOUBLE";
    SettingType["BOOLEAN"] = "BOOLEAN";
    SettingType["PASSWORD"] = "PASSWORD";
    SettingType["HIDDEN"] = "HIDDEN";
})(SettingType || (SettingType = {}));
//# sourceMappingURL=SettingType.js.map